import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CameraAdd from '../../../../Assets/StorefrontIcons/CameraAdd.svg';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';
import { setModal, setSelectionType } from '../../../../Features/storefrontSlice';
import ImageAdd from '../../../../Assets/ImageAdd.svg';

function DesktopBanner() {
    const dispatch = useDispatch();

    const mediaContainerRef = useRef(null);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);
    const { storefront } = useSelector((state) => state.storefront.storefront);
    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);
    const pageType = useSelector((state) => state.storefront.pageType);

    const [bannerHeight, setBannerHeight] = useState(0);
    const [logoSize, setLogoSize] = useState(0);
    const [cameraButton, setCameraButton] = useState(0);
    const [cameraButtonMargin, setCameraButtonMargin] = useState(0);

    const [logoTextSize, setLogoTextSize] = useState(0);
    const [logoTextLineHeight, setLogoTextLineHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            if (mediaContainerRef.current) {
                setBannerHeight((576 / 1080) * mediaContainerRef.current.clientWidth);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });

        if (mediaContainerRef.current) {
            resizeObserver.observe(mediaContainerRef.current);
        }

        updateHeight();

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        setLogoSize((zoomSize/100)*135);
        setCameraButton((zoomSize/100)*32);
        setCameraButtonMargin((zoomSize/100)*16);

        setLogoTextSize((zoomSize/100)*20);
        setLogoTextLineHeight((zoomSize/100)*22);
    }, [zoomSize]);

    function handleImageChange() {
        dispatch(setSelectionType('BACKGROUND'));
        dispatch(setModal('media-files'));
    }

    function handleLogoChange() {
        dispatch(setSelectionType('LOGO'));
        dispatch(setModal('media-files'));
    }

    const [hoverOnDiv, setHoverOnDiv] = useState(false);
    const [buttonVisible, setButtonVisible] = useState(false);
    
    useEffect(() => {
        if(hoverOnDiv) {
            setButtonVisible(true);
        }
        else {
            setButtonVisible(false);
        }
    }, [hoverOnDiv]);

    return (
        <div ref={mediaContainerRef} style={{ marginBottom: `calc(${logoSize/2}px + 16px)` }} className='w-full bg-[#868686] relative'>
            {
                pageType === 'STORE' && 
                <button onClick={handleImageChange} style={{ width: `${cameraButton}px`, height: `${cameraButton}px`, top: `${cameraButtonMargin}px`, right: `${cameraButtonMargin}px` }} className="outline-none absolute rounded-full bg-[#F16878] flex items-center justify-center">
                    <img className='size-3/4' src={CameraAdd} alt="" />
                </button>
            }

            {
                versionStack[versionIndex]?.webBackgroundImage ? 
                <img style={{ height: `${bannerHeight}px` }} className='w-full' src={versionStack[versionIndex]?.webBackgroundImage} alt="" /> : 
                <div style={{ height: `${bannerHeight}px` }} className="w-full"></div>
            }

            {
                pageType === 'STORE' ? 
                (
                    (versionStack[versionIndex]?.logoImage?.length > 0 || storefront?.Logo?.length > 0) ? 
                    <div 
                        onMouseEnter={() => setHoverOnDiv(true)} 
                        onMouseLeave={() => setHoverOnDiv(false)} 
                        style={{ width: `${logoSize}px`, bottom: `-${logoSize/2}px` }} className="rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2"
                    >
                        <img src={versionStack[versionIndex]?.logoImage || storefront?.Logo} alt="" />

                        <div onClick={handleLogoChange} className={`size-full absolute top-0 left-0 bg-[#00000095] flex items-center justify-center cursor-pointer transition-opacity duration-200 ${buttonVisible ? "opacity-100 visible" : "opacity-0 invisible"}"`}>
                            <img className="scale-75" src={ImageAdd} alt="" />
                        </div>
                    </div> :
                    <button onClick={handleLogoChange} style={{ width: `${logoSize}px`, height: `${logoSize}px`, bottom: `-${logoSize/2}px` }} className="outline-none rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2 bg-[#EAEAEA] flex items-center justify-center">
                        <p style={{ fontSize: `${logoTextSize}px`, lineHeight: `${logoTextLineHeight}px` }} className='text-[#1055EB] font-semibold'>Add Logo</p>
                    </button>
                ) : 
                <div style={{ width: `${logoSize}px`, bottom: `-${logoSize/2}px` }} className="rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2"
                >
                    <img src={versionStack[versionIndex]?.logoImage || storefront?.Logo} alt="" />
                </div>
            }
        </div>
    );
}

export default DesktopBanner;
